






























import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { ClientCampaignReport } from "@/models/campaign";
import DatePicker from "@/components/DatePicker.vue";
import CampaignsAPI from "@/services/campaigns";
import { UserModule } from "@/store/user";

import moment from "moment";
@Component({
  components: {
    Modal,
    DatePicker,
  },
})
export default class GenerateReport extends Vue {
  @Prop() campaign_id!: string;
  dialog = true;
  model: ClientCampaignReport = new ClientCampaignReport();
  range: string[] = [
    moment().startOf("month").format(),
    moment().endOf("month").format(),
  ];
  lang = "es";
  loading = false;
  languages: { isoCode: string; name: string }[] = [];

  created(): void {
    Object.keys(this.$i18n.messages).forEach((k) => {
      const lang = {
        isoCode: k,
        name: this.$t(`general.langs.${k}`).toString(),
      };
      this.languages.push(lang);
    });

    this.model.campaign_id = this.campaign_id;
    this.model.user_id = UserModule.currentUser.id;
  }
  get reportLink(): string {
    return `${window.location.origin}/report/campaign/${this.model.id}?token=${this.model.token}&lang=${this.lang}`;
  }
  async generateReport(): Promise<void> {
    this.loading = true;
    try {
      console.log(this.range);

      if (this.range.length == 2) {
        this.model.start = moment(this.range[0]).toDate();
        this.model.end = moment(this.range[1]).toDate();
        this.model.token = undefined;
        const r = await CampaignsAPI.generateReport(this.model);
        this.model = r;
      }
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  closeEditDialog(): void {
    this.$emit("close");
  }
}
